<template>
  <transition name="fade">
  <div class="header-container"  v-if="showHeader">
    <div class="content-wrapper">
      <a href="#"><img src="../assets/logo_black.png" width="200" alt="logo"/></a>
      <a href="#" v-scroll-to="'#scrollto-preorder'" class="preorder-btn">előrendelés</a>
    </div>
  </div>
  </transition>
</template>

<script>
export default {
  name: "TheHeader",
  data: function() {
    return {
      prevScrollPos: 0,
      showHeader: false,
    }
  },
  methods: {
    handleScroll() {
      window.onscroll = () => {
        const currentScrollPos = window.pageYOffset;
        const winHeight = window.innerHeight;
        if (winHeight - 100 < currentScrollPos && this.prevScrollPos < currentScrollPos) {
          this.showHeader = true
        } else if (winHeight > currentScrollPos && this.prevScrollPos > currentScrollPos) {
          this.showHeader = false
        }
        this.prevScrollPos = currentScrollPos;
      }
    }
  },
  created() {
    this.handleScroll()
  }
}
</script>

<style scoped>
.header-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 0;
  background: #fafafa;
  width: 100%;
  height: 80px;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.25);
  z-index: 100;
}

.content-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 10vw;
  width: 100%;
  max-width: 1400px;
}

.preorder-btn {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #EFBE3E;
  height: 40px;
  width: 170px;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.25);
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 5px;
}

.preorder-btn:hover {
  box-shadow: 3px 6px 10px rgba(0, 0, 0, 0.35);
}

img {
  cursor: pointer;
  user-select: none;
}

a {
  text-decoration: none;
  color: inherit;
}

.fade-enter-active {
  transition: opacity .4s ease-in-out;
}

.fade-leave-active {
  transform: translateY(-100%);
  transition: opacity .4s ease-in-out, 0.3s transform cubic-bezier(.3,.73,.3,.74);
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

@media only screen and (max-width: 900px) {
  .header-container {
    display: none;
  }
}


</style>
